import * as React from 'react';
import classnames from 'classnames';
import { MediaQuery, ReorderButton, CartButton } from '@grandvisionhq/common';
import { Icon } from '@grandvisionhq/icons';
import { useIntl, useFeatureToggles } from '@grandvisionhq/state';
import { CountrySwitcherMenu } from '../../CountrySwitcherMenu/CountrySwitcherMenu.js';
import { LocaleSwitcherMenu } from '../../LocaleSwitcherMenu/LocaleSwitcherMenu.js';

function HeaderIconWithLabel({ icon  }) {
    const { getLabel  } = useIntl();
    if (!icon.parameters || !icon.parameters.icon) {
        return null;
    }
    const href = icon.link && icon.link.href ? icon.link.href : '#';
    const iconLabel = icon.parameters.icon === 'location' ? getLabel('stores.form.findStore.title') : icon.label;
    return /*#__PURE__*/ React.createElement("a", {
        className: "header-menu__icon",
        href: href,
        "aria-label": iconLabel,
        title: iconLabel
    }, /*#__PURE__*/ React.createElement(Icon, {
        name: icon.parameters.icon
    }), /*#__PURE__*/ React.createElement("span", {
        className: "header-menu__label"
    }, iconLabel));
}
const HeaderMenu = ({ renderCartButton , renderWishlistMenuItem , showMultilingualComponents , availableLocales , myAccountButton , menuItems , toggleMobileSearch , countrySwitcherOptions , className , ordersUrl ,  })=>{
    const isAboveTabletPortrait = MediaQuery.useIsAbove(MediaQuery.BreakpointName.TABLET_PORTRAIT);
    const { getLabel  } = useIntl();
    const searchLabel = getLabel('common.header.search', {
        hideLabelKey: true
    });
    const isMobile = MediaQuery.useIsPhone();
    const { isReorderButtonEnabled , isWishlistEnabled  } = useFeatureToggles();
    const renderMenuItems = ()=>{
        return menuItems.map((item)=>{
            var ref, ref1, ref2, ref3;
            if ((item === null || item === void 0 ? void 0 : (ref = item.parameters) === null || ref === void 0 ? void 0 : ref.icon) !== 'cart' && (item === null || item === void 0 ? void 0 : (ref1 = item.parameters) === null || ref1 === void 0 ? void 0 : ref1.icon) !== 'favourite-empty') {
                return /*#__PURE__*/ React.createElement(HeaderIconWithLabel, {
                    key: item.label,
                    icon: item
                });
            } else if (renderWishlistMenuItem && (item === null || item === void 0 ? void 0 : (ref2 = item.parameters) === null || ref2 === void 0 ? void 0 : ref2.icon) === 'favourite-empty' && !isMobile) {
                return renderWishlistMenuItem(item);
            } else if (renderCartButton && (item === null || item === void 0 ? void 0 : (ref3 = item.parameters) === null || ref3 === void 0 ? void 0 : ref3.icon) === 'cart') {
                // Note: this will render the cart button twice if the wishlist feature flag is set to false,
                // but the menu item is still enabled in Bloomreach. OpCos should not set it in Bloomreach
                // if they do not intend to use the wish list feature.
                return renderCartButton(item);
            } else if (!isWishlistEnabled) {
                // Note: unfortunately we need to add a check here for the wish list feature. Why? Because this menu item should
                // be hidden on mobile but if we only check for isMobile in the second if-statement we will render the cart button twice.
                return /*#__PURE__*/ React.createElement(CartButton, {
                    key: item.label,
                    href: item.link && item.link.href,
                    className: "header-menu__icon",
                    label: item.label
                });
            }
        });
    };
    return /*#__PURE__*/ React.createElement("nav", {
        className: classnames('header-menu', className)
    }, /*#__PURE__*/ React.createElement("div", {
        className: "header-menu__icons"
    }, /*#__PURE__*/ React.createElement("button", {
        type: "button",
        className: "header-menu__search-button header-menu__icon",
        onClick: toggleMobileSearch,
        "aria-label": searchLabel
    }, /*#__PURE__*/ React.createElement(Icon, {
        name: "search"
    }), searchLabel && /*#__PURE__*/ React.createElement("span", {
        className: "header-menu__label"
    }, searchLabel)), isAboveTabletPortrait && /*#__PURE__*/ React.createElement(React.Fragment, null, countrySwitcherOptions && /*#__PURE__*/ React.createElement(CountrySwitcherMenu, {
        options: countrySwitcherOptions
    }), showMultilingualComponents && /*#__PURE__*/ React.createElement(LocaleSwitcherMenu, {
        availableLocales: availableLocales ? availableLocales : []
    }), myAccountButton, isReorderButtonEnabled && ordersUrl && /*#__PURE__*/ React.createElement(ReorderButton, {
        url: ordersUrl
    })), renderMenuItems()));
};
var HeaderMenu$1 = HeaderMenu;

export { HeaderIconWithLabel, HeaderMenu, HeaderMenu$1 as default };
//# sourceMappingURL=HeaderMenu.js.map
